export const blockIconsAndroidChargerNew = (
	<span className='material-symbols-outlined'>charger</span>
);
